import uniqid from 'uniqid';
import AjaxLoader from '../ajax-loader/ajax-loader';
import template from './templates/cart-modal';
import store from '@stores/cart/cart-store';

const DEFAULT_CONTEXT = {
    body: "Save your cart or continue without your most recent changes.",
    buttonContinue: 'Continue',
    buttonUpdate: 'Apply Updates',
    heading: 'Unsaved Changes',
};

export default class CartModal {
    #isSaved = false;

    constructor(context) {
        context = {
            ...DEFAULT_CONTEXT,
            ...context
        };

        const parsed = $.parseHTML(template);
        this.$el = $(parsed);
        
        this.$bodyLabel = this.$el.find('[data-label="body"]');
        this.$buttonContinueLabel = this.$el.find('[data-label="continue"]');
        this.$buttonUpdateLabel = this.$el.find('[data-label="update"]');
        this.$headingLabel = this.$el.find('[data-label="heading"]');

        this.$heading = this.$el.find('[data-region="heading"]');

        this.$updateCtrl = this.$el.find('[data-control="update"]');

        this.$loaderPlaceholder = this.$el.find('[data-placeholder="loader"]');

        this.loader = null;

        this.originEl = null;

        this.id = uniqid.time('cartModal_');
        this.context = context;

        this.init();
    }

    init() {
        this.renderLabels();
        this.setupAccessibility();
        this.setupListeners();
        this.setupLoader();

        this.render();
    }

    async onUpdateClick() {
        const { success } = await store.actions.updateLine();
        this.#isSaved = success;

        this.hide();
    }

    render() {
        $(document.body).append(this.$el);
    }

    renderLabels() {
        this.$bodyLabel.html(this.context.body);
        this.$buttonContinueLabel.html(this.context.buttonContinue);
        this.$buttonUpdateLabel.html(this.context.buttonUpdate);
        this.$headingLabel.html(this.context.heading);
    }

    setupAccessibility() {
        const headingId = `${this.id}_heading`;

        this.$el.attr(
            { 'id': this.id },
            { 'aria-labelledby': headingId }
        );

        this.$heading.attr('id', headingId);
    }

    setupListeners() {
        this.$updateCtrl.on('click', () => this.onUpdateClick());

        store.watch('loadingLine', (...[,,lineId]) => (this.loader.active = !!lineId));
    }

    setupLoader() {
        this.loader = new AjaxLoader(this.$loaderPlaceholder, {
            aria: false,
            size: 'xs'
        });
        
        this.loader.render();
    }

    prompt() {
        this.show();

        return new Promise((resolve) => {
            this.$el.one('hide.bs.modal', () =>{
                resolve(this.#isSaved);
                this.#isSaved = false;
            });
        });
    }

    show() {
        $(`#${this.id}`).modal('show', {
            focus: false
        });

        this.originEl = document.activeElement;

        if(this.originEl) {
            this.$el.one('hidden.bs.modal', () => {
                this.originEl.focus();
                this.originEl = null;
            });
        }
        
        this.$el.one('shown.bs.modal', () => this.$updateCtrl.get(0).focus());
    }

    hide() {
        $(`#${this.id}`).modal('hide');
    }
}
